import { render } from "./AllStudentView.vue?vue&type=template&id=277b0e04&scoped=true"
import script from "./AllStudentView.vue?vue&type=script&lang=js"
export * from "./AllStudentView.vue?vue&type=script&lang=js"

import "./AllStudentView.vue?vue&type=style&index=0&id=277b0e04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277b0e04"]])

export default __exports__